import ReactPlayer from 'react-player/vimeo'
import {FaPlay} from 'react-icons/fa'
import api from '../../../_metronic/helpers/api'
import {useLocation, useNavigate} from 'react-router-dom'
import {showAlert} from '../../redux/reducers/alertSlice'
import {useDispatch} from 'react-redux'
import { useState, useEffect } from 'react'
import {Tooltip, OverlayTrigger} from 'react-bootstrap'
import {KTSVG} from '../../../_metronic/helpers'
import back from '../../../_metronic/assets/custom-icons/back.png';
import reloadIcon from '../../../_metronic/assets/custom-icons/reload.png'
import useUtils from './useUtils'
const PreviewUnit = ({className}) => {
  const {state} = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {handleEdit, refetchVideo, getVideo} = useUtils()
  const values = state?.values
  const [retryLoading, setRetryLoading] = useState(false)
  const [id, setId] = useState(null)
  const [videos, setVideos] = useState(values?.videos || [])
  const imageURL = values?.bannerImage ? URL.createObjectURL(values?.bannerImage) : values?.imgUrl? values?.imgUrl : ''

  // Update local videos state when props change
  useEffect(() => {
    setVideos(values?.videos || [])
  }, [values?.videos])

  const publishUnit = async () => {
    try {
      const response = await api.patch(`unit/${values?.id}`, {status: 'published'})
      console.log(response)
      if (response?.data?.status) {
        dispatch(showAlert({message: 'Unit Published', variant: 'success'}))
        navigate('/unitlist')
      }
    } catch (error) {
      dispatch(showAlert({message: error?.response?.data?.message, variant: 'danger'}))
    }
  }

  const onEdit = async (id) => {
    const result = await handleEdit(id)
    console.log(result)
    navigate('/unitlist/editunit', {state: {result}})
  }

  const onClone = async (id2) => { 
    const result = await handleEdit(id2)
    const { id, code, name, description, ...newResult } = result;
    console.log(newResult)
    navigate('/unitlist/addunit', {state: {result:newResult}})
  }

  const submitUnit = (id) => {
    publishUnit(id)
  }

  const handleReload = async(videoId) => {
    try{
      setRetryLoading(true)
      setId(videoId)
      const response = await refetchVideo(videoId) 
      if(response){
        // Fetch updated video details to get the new status
        const updatedVideo = await getVideo(videoId)
        if(updatedVideo) {
          // Update the local videos state with the new video data
          setVideos(prevVideos => 
            prevVideos.map(video => 
              video.id === videoId 
                ? {...video, status: updatedVideo.status, errorMessage: updatedVideo.errorMessage}
                : video
            )
          )
        }
      }
    }catch (error) {
    }
    finally{
      setRetryLoading(false)
      setId(null)
    }
  }

  return (
    <>
     <div className={`card ${className}`}>
     <img
            onClick={() => navigate(-1)}
            style={{ width: '24px', height: '24px', cursor: 'pointer' }}
            src={back}
            className="me-2"
          />
      <div className='pt-4 px-4 mb-3' style={{fontSize: '14px'}}>
        <div className='d-flex justify-content-between'>
          <div className='d-flex align-items-start flex-wrap gap-3'>
            {values?.bannerImage? (
              <img
                style={{cursor: 'pointer', width: '400px', height: '200px', objectFit:'cover'}}
                src={imageURL}
                alt=''
              ></img>
            ):values?.imgUrl? (
              <img
              style={{cursor: 'pointer', width: '400px', height: '200px', objectFit:'cover'}}
              src={values?.imgUrl}
              alt=''
            ></img>
            ):(
              <img  src='https://placehold.co/400x200?text= No Image' />
            )}
            <div className='d-flex flex-column t-14 gap-2 mt-2'>
            <div className='d-flex gap-1'>
                  <div className='fw-bold m-0'>Code:</div>
                  <div>{values?.code}</div>
                </div>
              <div className='d-flex gap-1'>
                <div className='fw-bold m-0'>Unit Name:</div>
                <div>{values?.unitName}</div>
              </div>
              <div className='d-flex gap-1'>
                <div className='fw-bold m-0'>Cohort:</div>
                <div>{values?.cohort}</div>
              </div>
              <div className='d-flex gap-1'>
                <div className='fw-bold m-0'>Tags:</div>
                <div>
                  {values?.tags?.map((val, index) =>
                    values?.tags?.length - 1 === index ? val : val + ', '
                  )}
                </div>
              </div>
              <div className='d-flex gap-1'>
                <div className='fw-bold m-0'>Language:</div>
                <div>{values?.language}</div>
              </div>
            </div>
          </div>

          <div>
            <button type='button' className='btn btn-primary text-nowrap ms-2 mt-2 me-2' onClick={()=>onClone(values?.id)}>
              Clone
            </button>
            <button type='button' className='btn btn-primary text-nowrap ms-2 mt-2 me-2' onClick={()=>onEdit(values?.id)}>
              Edit Unit
            </button>
            {values?.status!=='published'&&<button type='button' className='btn text-nowrap btn-primary ms-2 mt-2 me-2' onClick={submitUnit}>
              Publish Unit
            </button>}
          </div>
        </div>
        <div className='mt-3'>
          <div className='fw-bold mt-8'>Description</div>
          <div className='mt-2'>{values?.shortDescription}</div>
        </div>
        <hr className='hr-3 my-8' />
        <div>
          <div className='mt-3 d-flex justify-content-start align-items-start gap-10 flex-wrap'>
            {videos &&
              videos?.map((val, index) => (
                <div
                  className='shadow-lg overflow-hidden bg-white text-black'
                  key={index}
                  style={{backgroundColor: 'white', width: '220px', borderRadius: '9px'}}
                >
                  <div className='player-wrapper position-relative'>
                    <ReactPlayer
                      className='react-player'
                      width='100%'
                      height='160px'
                      url={val?.link}
                    />
                    <div
                      className='icon-overlay position-absolute'
                      style={{left: '50%', top: '50%', transform: 'translate(-50%, -50%)'}}
                    >
                      <FaPlay size={50} color='black' />
                    </div>
                  </div>

                  <hr className='hr' />
                  <div className='px-2 ' style={{height:'90px'}}>
                    <div className='fw-bold fs-7 d-flex justify-content-between align-items-center'>
                      {val?.title?.length > 28 ? val.title.slice(0, 28) + ' ....' : val.title}

                      {(val.status === 'pending' || val.status === 'warning') && val.errorMessage && (
                        <div className='d-flex gap-1 align-items-center'>
                          <OverlayTrigger
                            placement='top'
                            overlay={
                              <Tooltip id={`tooltip-pending-${val.id}`}>
                                {val.errorMessage}
                              </Tooltip>
                            }
                          >
                            <span className='ms-2' style={{cursor: 'pointer', color: '#FFA500'}}>
                            <KTSVG
                                path='/media/icons/duotune/general/gen044.svg'
                                className={`svg-icon-1 
                                ${val?.status === 'pending' ? 'text-danger' : 'text-warning'}
                                `}
                            />
                            </span>
                          </OverlayTrigger>
                          {retryLoading && val.id === id?
                          (
                            <div className='spinner-border spinner-border-sm align-middle ms-2'></div>
                          ):(<img className='cursor-pointer' onClick={()=>handleReload(val.id)} src={reloadIcon} style={{height:'19px'}}/>)}
                        </div>
                      )}
                    </div>
                    <div className='mb-3 text-start fs-8 fw-light mt-2'>
                      {val?.description?.length > 90
                        ? val?.description.slice(0, 90) + ' ....'
                        : val?.description}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
      </div>
    </>
  )
}

export {PreviewUnit}
